export default {"src":"/_next/static/media/mandatory.f552e07d.svg","height":39,"width":108,"blurWidth":0,"blurHeight":0};